import { useEffect } from 'react';

import type { HotkeyItem } from './types';
import { matchesHotkey } from './utils';

/**
 * Hook to register keyboard hotkeys
 * Accepts items with optional hotkeys
 */
export const useHotkeys = <T extends HotkeyItem>(items: T[], enabled = true) => {
  useEffect(() => {
    if (!enabled || items.length === 0) return;

    const handleKeyPress = (event: KeyboardEvent) => {
      const target = event.target as HTMLElement;
      if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
        return;
      }

      for (const item of items) {
        if (!item.hotkey) continue;

        if (matchesHotkey(event, item.hotkey)) {
          event.preventDefault();
          item.handler();
          break;
        }
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [items, enabled]);
};
